import React from 'react';
import { Container, Col, Row, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet'; // Importing Helmet for SEO
import IQTestingImg from '../img/IQ_testing.png'; // Image for IQ and Aptitude Testing

const IQ_Testing = () => {
    const cardData = [
        {
            id: 1,
            title: 'IQ Testing Overview',
            text: 'IQ testing measures a person’s intellectual abilities and potential. It is designed to assess cognitive functions such as reasoning, problem-solving, and memory. IQ tests are used for various purposes, including educational assessment, and understanding cognitive strengths and weaknesses.',
        },
        {
            id: 2,
            title: 'Types of IQ Tests',
            text: 'There are several types of IQ tests, including the Stanford-Binet Intelligence Scale, the Wechsler Adult Intelligence Scale (WAIS), and the Raven’s Progressive Matrices. These tests measure different aspects of intelligence, such as verbal reasoning, quantitative reasoning, and spatial abilities.',
        },
        {
            id: 3,
            title: 'Aptitude Testing Overview',
            text: 'Aptitude testing is designed to assess an individual’s potential for learning or developing certain skills. It evaluates areas such as mathematical reasoning, language proficiency. Aptitude tests are widely used in career counseling and educational placement to match.',
        },
        {
            id: 4,
            title: 'Types of Aptitude Tests',
            text: 'Aptitude tests come in various forms, including verbal, numerical and abstract reasoning tests. The most common aptitude tests include the Graduate Management Admission Test, Scholastic Assessment Test, and Differential Aptitude Tests, which are used for career assessments.',
        },
        {
            id: 5,
            title: 'Purpose of IQ Testing',
            text: 'The primary purpose of IQ testing is to measure an individual’s intellectual capabilities relative to others. It is commonly used in educational settings to identify gifted students or those with learning disabilities, as well as to assess eligibility for advanced programs.',
        },
        {
            id: 6,
            title: 'Purpose of Aptitude Testing',
            text: 'Aptitude tests help assess an individual’s ability to perform certain tasks or excel in specific areas, often related to career or academic choices. These tests provide valuable insight into a person’s natural strengths and weaknesses, allowing for better educational guidance.',
        },
    ];

    return (
        <div>
            <Helmet>
                <title>IQ and Aptitude Testing | Understand Cognitive Abilities & Career Potential</title>
                <meta name="description" content="Explore IQ and aptitude testing to gain insights into cognitive abilities, reasoning skills, and career potential. Learn about different IQ and aptitude tests and their purposes." />
                <meta name="keywords" content="IQ Testing, Aptitude Testing, Cognitive Abilities, Career Counseling, Intelligence Tests, Educational Assessment" />
                <meta name="author" content="Your Company Name" />
                <meta property="og:title" content="IQ and Aptitude Testing | Understand Cognitive Abilities & Career Potential" />
                <meta property="og:description" content="Explore IQ and aptitude testing for cognitive abilities and career potential. Learn about different tests and their purpose in education and career counseling." />
                <meta property="og:image" content={IQTestingImg} />
                <meta property="og:url" content="https://yourwebsite.com/iq-testing" />
            </Helmet>

            <Container>
                <Row>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <img src={IQTestingImg} alt="IQ and Aptitude Testing" className='img-fluid h-100 w-100 rounded-md '/>
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <h1 style={{fontFamily:'monospace'}} className='mb-4'>IQ and Aptitude Testing</h1>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>IQ and aptitude testing are key tools in understanding cognitive and problem-solving abilities. IQ tests are designed to measure intellectual ability, while aptitude tests assess the potential to develop specific skills. Both types of testing provide valuable insights into individual strengths, areas for growth, and optimal educational or career paths.</p>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>Whether you’re assessing academic performance, career suitability, or potential for growth, these tests play a critical role in guiding personal and professional decisions.</p>
                    </Col>
                </Row>
            </Container>

            <Container className='mb-5'>
                <Row>
                    {cardData.map((card) => (
                        <Col xs={12} sm={6} md={6} lg={6} className="g-4" key={card.id}>
                            <Card className='bg-info-subtle'>
                                <Card.Body>
                                    <Card.Title style={{color:'#093c60'}} className='fw-bold'>{card.title}</Card.Title>
                                    <Card.Text>{card.text}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default IQ_Testing;
